(() => {
  const refresh = (root = document) => {
    root.querySelectorAll('[data-swatch-item]:not(button)').forEach(item => {
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-label', item.dataset.value || item.textContent.trim());
      item.setAttribute('aria-pressed', String(item.classList.contains('is--selected')));
      item.setAttribute('aria-disabled', String(item.classList.contains('is--soldout') || item.classList.contains('is--unavailable')));
    });
  };
  document.addEventListener('keydown', event => {
    const item = event.target.closest('[data-swatch-item][role="button"]');
    if (!item || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    if (item.getAttribute('aria-disabled') !== 'true') item.click();
  });
  const init = () => {
    // Anchor the existing dynamic badge to the visible photo, including contain-fit images.
    document.querySelectorAll('.template-product [data-product-single-badge]').forEach(badge => {
      if (badge.dataset.alvorePositioned) return;
      const gallery = badge.parentElement;
      badge.dataset.alvorePositioned = 'true';
      let frame;
      const position = () => {
        const img = gallery.querySelector('[data-main-slide].is-selected img:not(.bee-img-noscript)') || gallery.querySelector('[data-main-media] img:not(.bee-img-noscript)');
        if (!img || !badge.offsetParent) return;
        const box = img.getBoundingClientRect();
        const parent = badge.offsetParent.getBoundingClientRect();
        if (!box.width || !box.height) return;
        const style = getComputedStyle(img);
        const ratio = (img.naturalWidth || img.width) / (img.naturalHeight || img.height);
        let width = box.width, height = box.height;
        if (style.objectFit === 'contain' && ratio > 0) {
          width = Math.min(box.width, box.height * ratio);
          height = width / ratio;
        }
        const positions = style.objectPosition.split(' ');
        const fraction = value => value === 'left' || value === 'top' ? 0 : value === 'right' || value === 'bottom' ? 1 : value.endsWith('%') ? parseFloat(value) / 100 : .5;
        const left = box.left + (box.width - width) * fraction(positions[0]);
        const top = box.top + (box.height - height) * fraction(positions[1] || '50%');
        badge.style.left = 'auto';
        badge.style.right = `${Math.max(8, parent.right - left - width + 12)}px`;
        badge.style.top = `${Math.max(8, top - parent.top + 12)}px`;
        gallery.querySelectorAll('[data-main-media] .flickitybee-prev-next-button').forEach(arrow => {
          const anchor = arrow.offsetParent?.getBoundingClientRect();
          if (!anchor) return;
          const previous = arrow.classList.contains('previous');
          arrow.style.setProperty('left', previous ? `${left - anchor.left + 12}px` : 'auto', 'important');
          arrow.style.setProperty('right', previous ? 'auto' : `${anchor.right - left - width + 12}px`, 'important');
          arrow.style.setProperty('top', `${top - anchor.top + height / 2}px`, 'important');
        });
      };
      const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(position); };
      const resize = new ResizeObserver(schedule);
      resize.observe(gallery);
      const changes = new MutationObserver(schedule);
      changes.observe(gallery, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'src', 'srcset']});
      gallery.addEventListener('load', schedule, true);
      gallery.addEventListener('transitionend', schedule);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(gallery)) { resize.disconnect(); changes.disconnect(); cancelAnimationFrame(frame); }
      });
      schedule();
    });
    const desktop = window.matchMedia('(min-width:750px)');
    document.querySelectorAll('.alvore-footer__column').forEach(column => {
      if (column.dataset.alvoreResponsive) return;
      column.dataset.alvoreResponsive = 'true';
      const sync = () => { column.open = desktop.matches; };
      sync();
      desktop.addEventListener('change', sync);
    });
    refresh();
    document.querySelectorAll('.bee-swatch').forEach(swatch => {
      if (swatch.dataset.alvoreAccessible) return;
      swatch.dataset.alvoreAccessible = 'true';
      new MutationObserver(() => refresh(swatch)).observe(swatch, {subtree: true, attributes: true, attributeFilter: ['class'], childList: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
